import { useState } from "react";
import { Box, Button, IconButton, Popover, Stack, Tooltip, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// Delete control for a flow node: round button at the node's top-right corner
// (shown on hover), with a small "Delete this step?" confirmation. Calls the node's own onDelete.
export default function NodeDeleteButton({ visible, onDelete }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    return (
        <>
            <Tooltip title="Delete step" arrow placement="top">
                <IconButton
                    className="nodrag"
                    aria-label="delete step"
                    onClick={(e) => {
                        e.stopPropagation();
                        setAnchorEl(e.currentTarget);
                    }}
                    sx={{
                        position: "absolute",
                        top: -12,
                        right: -12,
                        zIndex: 5,
                        width: 26,
                        height: 26,
                        p: 0,
                        color: "#dc2626",
                        bgcolor: "#fff",
                        border: "1.5px solid #fecaca",
                        boxShadow: "0 4px 10px -4px rgba(220,38,38,0.45)",
                        opacity: visible || open ? 1 : 0,
                        pointerEvents: visible || open ? "auto" : "none",
                        transform: visible || open ? "scale(1)" : "scale(0.8)",
                        transition: "all .15s ease",
                        "&:hover": { color: "#fff", bgcolor: "#dc2626", borderColor: "#dc2626" },
                    }}
                >
                    <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                </IconButton>
            </Tooltip>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                    className: "nodrag",
                    sx: { mt: 0.75, p: 1.5, width: 220, borderRadius: 2.5, border: "1px solid #fecaca", boxShadow: "0 12px 28px -12px rgba(15,23,42,0.35)" },
                }}
            >
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
                    <Box sx={{ width: 26, height: 26, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#dc2626", bgcolor: "#fee2e2" }}>
                        <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                    </Box>
                    <Typography sx={{ fontSize: 13.5, fontWeight: 800, color: "#0f172a" }}>Delete this step?</Typography>
                </Stack>
                <Typography sx={{ fontSize: 12, color: "#64748b", mb: 1.25 }}>
                    The step and its connections will be removed.
                </Typography>
                <Stack direction="row" spacing={1}>
                    <Button
                        fullWidth
                        size="small"
                        onClick={() => setAnchorEl(null)}
                        sx={{ height: 32, borderRadius: 2, textTransform: "none", fontWeight: 700, color: "#475569", border: "1.5px solid #e2e8f0", "&:hover": { bgcolor: "#f8fafc" } }}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        size="small"
                        onClick={() => {
                            setAnchorEl(null);
                            onDelete();
                        }}
                        sx={{ height: 32, borderRadius: 2, textTransform: "none", fontWeight: 700, color: "#fff", bgcolor: "#dc2626", "&:hover": { bgcolor: "#b91c1c" } }}
                    >
                        Delete
                    </Button>
                </Stack>
            </Popover>
        </>
    );
}
